export const SET_TOURS = 'SET_TOURS';
export const SET_BOOKINGS = 'SET_BOOKINGS';
export const SET_CAROUSEL_POSITIONS = 'SET_CAROUSEL_POSITIONS';
export const SET_CAROUSEL_ACTIVE_KEY = 'SET_CAROUSEL_ACTIVE_KEY';
export const SET_CAROUSEL_INFO = 'SET_CAROUSEL_INFO';
export const RESET_CAROUSEL_TILE = 'RESET_CAROUSEL_TILE';
export const SET_ACTIVE_CAROUSEL_ID = 'SET_ACTIVE_CAROUSEL_ID';

